import ChartArrow from './ChartArrow'

export default ChartArrow
